import { ReactNode } from 'react';

export type ApplianceCareArticleProps = {
  icon: ReactNode;
  description: string;
  additionalDescription?: string;
  key?: number;
};

export const ChooseApplianceCareArticle = ({ icon, description }: ApplianceCareArticleProps) => (
  <article className="flex flex-col items-center text-center">
    <figure className="mb-space-400 text-(--icon-button-primary-default)">{icon}</figure>
    <p>{description}</p>
  </article>
);
